export default "__VITE_ASSET__72SDsR9J__"